//returns a string that is used to locate the audio file in the android device
export default function(audio: number) {
    return '/data/user/0/com.yoguin/files/https%3A/yoguin.com/audio/aprendiendo-0'+audio+'.mp3'
};